<template>
  <div>
<!--    <div v-html="comment" v-for="comment in objs.commentsu"></div>-->

<!--    {{objs.commentsu }}-->
    <CCard class="bg-style2">
      <CCardHeader class="bg-gradient-danger text-white" style="border-top-left-radius: 1rem; border-top-right-radius: 1rem ">
        <span class="font-weight-bold h6"> <CIcon v-if="icon" :name="icon"/> {{ caption }} </span>
      </CCardHeader>
      <CCardBody>
        <CRow v-for="obj in objs.commentsu" class="ml-3 mb-3">
          <CCol col="4"> {{ obj.users.userinfo.prefix.filter(obj => { return (obj.key == lang) })[0].value }} {{obj.users.userinfo.firstName.filter(obj => { return (obj.key == lang) })[0].value}} {{ obj.users.userinfo.lastName.filter(obj => { return (obj.key == lang) })[0].value }}  </CCol>

          <CCol> <div v-html="obj.comment"></div> </CCol>
        </CRow>
        <quill-editor class="" :content="objs.comment" @change="onEditor" />
      </CCardBody>
    </CCard>

  </div>
</template>

<script>

import Vue from 'vue'
import {mapGetters} from 'vuex'
import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
Vue.use(VueQuillEditor)

export default {
  name: 'QEditor',
  props: {
    icon: {
      type: String,
      default: 'cil-user'
    },
    caption: {
      type: String,
      default: ' Comment '
    },
    objs: {
      type: Object,
      default: {
        comment:""
      }
    }
  },

  data: function () {
    return {
    }
  },

  mounted () {
  },

  created () {
    this.onInit()

  },
  beforeDestroy () {

  },

  methods: {
    onInit(){
    },


    onEditor(html, text, quill) {
      this.objs.comment = html.html
    },


  },

  computed: {
    ...mapGetters({
      lang: "setting/lang",
    })
  },

  watch: {
  }

}
</script>
<style >


</style>
